import { Employee } from './employee/employee';

export class Unavailability {
	readonly id: number;
	employee: Employee;
	day: string;
	start: number;
	end: number;

	constructor() {}
}
